var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dnevnik-tabela',{attrs:{"podatki":_vm.podatki,"nalaganje-tabele":_vm.nalaganjeTabele}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-084773e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Mojprofil/Varnost/DnevnikAktivnosti.vue
// module id = oJPw
// module chunks = 3